// extracted by mini-css-extract-plugin
export default {"button":"Button_button__yx--W","send":"Button_send__uIa8v"};